import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(
  React.forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5993 4.4995C8.87545 4.4995 9.0993 4.72335 9.0993 4.9995V7.9995C9.0993 8.27564 8.87545 8.4995 8.5993 8.4995C8.32316 8.4995 8.0993 8.27564 8.0993 7.9995V4.9995C8.0993 4.72335 8.32316 4.4995 8.5993 4.4995Z"
        fill="currentColor"
      />
      <path
        d="M8.59928 11.3328C8.96747 11.3328 9.26595 11.0344 9.26595 10.6662C9.26595 10.298 8.96747 9.9995 8.59928 9.9995C8.23109 9.9995 7.93262 10.298 7.93262 10.6662C7.93262 11.0344 8.23109 11.3328 8.59928 11.3328Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46281 1.4128L11.3389 2.31078L13.2106 3.21766C13.7554 3.48159 14.1513 3.97804 14.2874 4.56786L14.755 6.5945L15.213 8.62334C15.3463 9.2138 15.205 9.83286 14.8287 10.307L13.5358 11.9362L12.2352 13.5592C11.8566 14.0316 11.2845 14.3071 10.6792 14.3086L8.59933 14.3135L6.51944 14.3086C5.91412 14.3071 5.34203 14.0316 4.9635 13.5592L3.66284 11.9362L2.36992 10.307C1.99364 9.83286 1.85234 9.2138 1.98563 8.62334L2.44363 6.5945L2.91127 4.56786C3.04737 3.97804 3.44327 3.48159 3.98802 3.21766L5.85979 2.31078L7.73584 1.4128C8.28184 1.15146 8.91682 1.15146 9.46281 1.4128ZM9.03107 2.3148L10.9028 3.21071L10.9071 3.21278L12.7746 4.1176C13.047 4.24956 13.2449 4.49779 13.313 4.79269L13.7796 6.8147L13.7806 6.81934L14.2376 8.84354C14.3042 9.13877 14.2336 9.4483 14.0454 9.68538L12.7555 11.3109L12.7525 11.3146L11.4548 12.9339C11.2655 13.1701 10.9795 13.3078 10.6768 13.3086L8.6017 13.3135H8.59695L6.52182 13.3086C6.21916 13.3078 5.93311 13.1701 5.74384 12.9339L4.44615 11.3146L4.44319 11.3109L3.15323 9.68538C2.96509 9.4483 2.89444 9.13877 2.96109 8.84354L3.41856 6.81703L3.88567 4.79269C3.95372 4.49779 4.15167 4.24956 4.42404 4.1176L6.29367 3.21175L8.16759 2.3148C8.44058 2.18413 8.75807 2.18413 9.03107 2.3148Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);
